import { useEffect, useState } from 'react'
import styled from 'styled-components'

import theme from '~/shared/styles/theme'
import useCountdown from '~/shared/utils/useCountdown'

interface Props {
  start_at: string
}

function CircleApplyCountdown({ start_at }: Props) {
  const remainingTime = useCountdown(start_at)
  const [isTimeOver, setIsTimeOver] = useState(false)

  useEffect(() => {
    if (
      remainingTime.days === '00' &&
      remainingTime.hours === '00' &&
      remainingTime.minutes === '00' &&
      remainingTime.seconds === '00'
    ) {
      setTimeout(() => {
        setIsTimeOver(true)
      }, 3000)
    } else {
      setIsTimeOver(false)
    }
  }, [remainingTime])

  return (
    <>
      {!isTimeOver && (
        <Wrapper>
          <span>{remainingTime.days}일</span>
          <span>{remainingTime.hours}시간</span>
          <span>{remainingTime.minutes}분</span>
          <span>{remainingTime.seconds}초</span>
          남음
        </Wrapper>
      )}
    </>
  )
}

export default CircleApplyCountdown

const Wrapper = styled.div`
  display: flex;
  gap: 10px;

  margin: 0 auto;

  font-family: NanumSquareNeo-ExtraBold, sans-serif;
  color: ${theme.colors.warning};
`
